/* Resolve public HLM/SLM placeholders, including translated span text/attribute order. */
(() => {
  'use strict';
  function hydrate(root, values) {
    const spans = [];
    if (root?.matches?.('span[data-global]')) spans.push(root);
    root?.querySelectorAll?.('span[data-global]').forEach(span => spans.push(span));
    for (const span of spans) {
      const key = span.dataset.global;
      if (Object.hasOwn(values, key) && typeof values[key] === 'string' && span.textContent !== values[key]) span.textContent = values[key];
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { hydrate };
  if (typeof document === 'undefined') return;
  const start = () => {
    let values;
    try { values = JSON.parse(document.querySelector('#hlx-public-data')?.textContent || '{}'); }
    catch { return; }
    hydrate(document.body, values);
    // Shopify translation/section updates may insert new placeholders later.
    new MutationObserver(records => records.forEach(record => hydrate(record.target, values)))
      .observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
